import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const AdCard = ({ ad, size = 'normal' }) => {
  // Check if link is internal (starts with /) or external
  const isInternalLink = ad.link_url && ad.link_url.startsWith('/');
  
  const cardContent = (
    <div className={`relative ${size === 'small' ? 'aspect-square' : 'aspect-video'} bg-card rounded-sm overflow-hidden`}>
      <img
        src={ad.image_url || 'https://images.unsplash.com/photo-1514933651103-005eec06c04b?w=800'}
        alt={ad.title}
        className="w-full h-full object-cover"
      />
      
      {/* Sponsored tag */}
      <div className="absolute top-3 right-3 sponsored-tag text-white">
        Sponsored
      </div>

      {/* Info overlay */}
      <div className="absolute bottom-0 left-0 right-0 p-4 gradient-scrim">
        <h3 className="font-heading font-bold text-base mb-1 truncate">{ad.title}</h3>
        <p className="text-xs text-muted-foreground truncate">{ad.business_name}</p>
        {ad.description && (
          <p className="text-xs text-muted-foreground mt-1 line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity">
            {ad.description}
          </p>
        )}
      </div>

      {/* Hover link indicator */}
      <div className="absolute inset-0 bg-primary/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
        <ExternalLink size={24} className="text-white" />
      </div>
    </div>
  );

  // Use Link for internal routes, anchor for external URLs
  if (isInternalLink) {
    return (
      <Link to={ad.link_url}>
        <motion.div
          whileHover={{ scale: 1.02 }}
          className={`group relative block rounded-sm overflow-hidden bg-card border border-border card-hover ${
            ad.is_premium ? 'tracing-beam p-[2px]' : ''
          }`}
          data-testid={`ad-card-${ad.id}`}
        >
          {cardContent}
        </motion.div>
      </Link>
    );
  }

  return (
    <motion.a
      href={ad.link_url || '#'}
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ scale: 1.02 }}
      className={`group relative block rounded-sm overflow-hidden bg-card border border-border card-hover ${
        ad.is_premium ? 'tracing-beam p-[2px]' : ''
      }`}
      data-testid={`ad-card-${ad.id}`}
    >
      {cardContent}
    </motion.a>
  );
};

export default AdCard;
